// Game constants
export const QUESTION_TIME_LIMIT = 30; // 30 seconds per question
export const MAX_QUESTIONS = 10; // Maximum number of questions per game

// Game statuses
export const GAME_STATUS = {
  WAITING: 'waiting',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
} as const;

export type GameStatus = typeof GAME_STATUS[keyof typeof GAME_STATUS];

// Question difficulties
export const DIFFICULTY = {
  EASY: 'easy',
  MEDIUM: 'medium',
  HARD: 'hard',
} as const;

export type Difficulty = typeof DIFFICULTY[keyof typeof DIFFICULTY];

// Answer statuses
export const ANSWER_STATUS = {
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
  SKIPPED: 'skipped',
  TIMEOUT: 'timeout',
} as const;

export type AnswerStatus = typeof ANSWER_STATUS[keyof typeof ANSWER_STATUS];

// Game events
export const GAME_EVENTS = {
  PLAYER_JOINED: 'player_joined',
  PLAYER_LEFT: 'player_left',
  GAME_STARTED: 'game_started',
  QUESTION_ASKED: 'question_asked',
  ANSWER_SUBMITTED: 'answer_submitted',
  GAME_COMPLETED: 'game_completed',
} as const;

export type GameEvent = typeof GAME_EVENTS[keyof typeof GAME_EVENTS];
